import React from "react";
import PropTypes from "prop-types";
import styles from "./StandingOrderDropdownList.module.css";
import classNames from "classnames";
import FeedItemOptionsDropdown from "../FeedItemOptionsDropdown";
import StandingOrderCardInfoDropdown from "../StandingOrderCardInfoDropdown";
import FeedItemContentsDropdown from "../FeedItemContentsDropdown";
import { useState, useEffect, useRef, useMemo } from "react";
import dayjs from "dayjs";
import { isEqual } from "lodash-es";

/**
 * A list of dropdowns with a Standard Content feed item’s properties.
 * Only one dropdown may be open at a given time.
 */

export function StandingOrderDropdownList({ feedItem, setFeedItem, isNew }) {
  /**
   * Update useState to access the correct structure.
   * Prevent runtime crashes if 'content' or 'sections' are undefined
   * Align with the fixed 'mapApiResponseToFeedItem()' output in src/NewsAdmin/utils/mapFeedItems.js
   */
  const [sections, setSections] = useState(
    feedItem.data?.card?.content?.sections || []
  );

  useEffect(() => {
    // const currentSections = feedItem?.data?.card?.content?.sections;

    // if (!isEqual(currentSections, sections)) {
      setFeedItem((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          content: {
            ...prev.data.content,
            sections: sections,
          },
          card: {
            ...prev.data.card,
            content: {
              ...prev.data.card.content,
              sections: sections,
            },
          },
        },
      }));
    // }
  }, [sections]);

  // Decides what dropdown is open contents, info, options
  const [dropdownOpen, setDropdownOpen] = useState("close");

  const setIsOpen = (dropdown) => {
    // console.log("[Dropdown Set]", dropdown); // inside setIsOpen()
    setDropdownOpen(dropdown);
  };

  // Feed Item Options Dropdown
  const [sendUpdate, setSendUpdate] = useState(true);

  const handleSendUpdate = () => {
    setSendUpdate(!sendUpdate);
  };

  return (
    <>
      {/* Work on setting up setCard info to pass in setFeedItem Look at FeedItemContentsDropdown for reference */}
      {["close", "options"].includes(dropdownOpen) && ( // Fix rendering logic to disply content upon section expansion
        //need to update data in this component once I ask questions about structure
        <FeedItemOptionsDropdown
          isOpen={dropdownOpen === "options"} // Update logic for proper rendering (equality instead of comparison)
          onClick={setIsOpen}
          // Pull only the config we need, not the entire feedItem
          optionsConfig={{
            ...feedItem?.options,
          }}
          /**
           * Avoid wiping unrelated keys in feedItem when only updating the options slice.
           * Especially imporant when syncing values from individual dropdown controls.
           */
          setOptionsConfig={(newOptions) => {
            // console.log(newOptions);
            setFeedItem((prev) => ({
              ...prev,
              options: {
                ...prev.options,
                ...newOptions,
              },
            }));
          }}
          isEdit={isNew}
          sendUpdate={sendUpdate}
          setSendUpdate={handleSendUpdate}
        />
      )}

      {/* Work on setting up setCard info to pass in setFeedItem Look at FeedItemContentsDropdown for reference*/}
      {(dropdownOpen == "close" || dropdownOpen == "info") && (
        <StandingOrderCardInfoDropdown
          isOpen={dropdownOpen == "info" ? true : false}
          onClick={setIsOpen}
          cardInformation={feedItem}
          setCardInformation={setFeedItem}
        />
      )}

      {(dropdownOpen == "close" || dropdownOpen == "contents") && (
        <FeedItemContentsDropdown
          sections={sections}
          setSections={setSections}
          isOpen={dropdownOpen == "contents" ? true : false}
          onClick={setIsOpen}
        />
      )}
    </>
  );
}

StandingOrderDropdownList.propTypes = {
  /**
   * Object that contains all of a Standard Content feed item’s properties.
   */
  feedItem: PropTypes.object,

  /**
   * Function that sets the value of the feedItem prop.
   */
  setFeedItem: PropTypes.func,
};
